import { render, staticRenderFns } from "./versionUpdate.vue?vue&type=template&id=9cca5b7a&scoped=true"
import script from "./versionUpdate.vue?vue&type=script&lang=js"
export * from "./versionUpdate.vue?vue&type=script&lang=js"
import style0 from "./versionUpdate.vue?vue&type=style&index=0&id=9cca5b7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cca5b7a",
  null
  
)

export default component.exports